/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_In_PersonInputs */

const en_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-Person`)
};

const es_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En persona`)
};

const fr_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En personne`)
};

const de_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönlich`)
};

const ja_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対面`)
};

const zh_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线下面对面`)
};

const ar_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حضور شخصي`)
};

const id_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tatap Muka`)
};

const it_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di Persona`)
};

const ru_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Личная встреча`)
};

const pt_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presencial`)
};

const ko_val_in_person = /** @type {(inputs: Val_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대면`)
};

/**
* | output |
* | --- |
* | "In-Person" |
*
* @param {Val_In_PersonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_in_person = /** @type {((inputs?: Val_In_PersonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_In_PersonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_in_person(inputs)
	if (locale === "es") return es_val_in_person(inputs)
	if (locale === "fr") return fr_val_in_person(inputs)
	if (locale === "de") return de_val_in_person(inputs)
	if (locale === "ja") return ja_val_in_person(inputs)
	if (locale === "zh") return zh_val_in_person(inputs)
	if (locale === "ar") return ar_val_in_person(inputs)
	if (locale === "id") return id_val_in_person(inputs)
	if (locale === "it") return it_val_in_person(inputs)
	if (locale === "ru") return ru_val_in_person(inputs)
	if (locale === "pt") return pt_val_in_person(inputs)
	return ko_val_in_person(inputs)
});